// components/DocumentTypesLabel.tsx
import React from "react";
import { DocumentTypes } from "../documentTypes";

type DocTypeLabels = Record<DocumentTypes, { pl: string; en: string }>;

export const DOC_TYPE_LABELS: DocTypeLabels = {
    URS: { pl: "URS (Wymagania Użytkownika)", en: "URS (User Requirements Specification)" },
    RA: { pl: "RA (Analiza ryzyka)", en: "RA (Risk Analysis)" },
    DQ: { pl: "DQ (Kwalifikacja Projektowa)", en: "DQ (Design Qualification)" },
    IQ: { pl: "IQ (Kwalifikacja Instalacyjna)", en: "IQ (Installation Qualification)" },
    OQ: { pl: "OQ (Kwalifikacja Operacyjna)", en: "OQ (Operational Qualification)" },
    PQ: { pl: "PQ (Kwalifikacja Wydajnościowa)", en: "PQ (Performance Qualification)" },
    FAT: { pl: "FAT (Testy akceptacyjne w fabryce)", en: "FAT (Factory Acceptance Test)" },
    SAT: { pl: "SAT (Testy akceptacyjne na miejscu)", en: "SAT (Site Acceptance Test)" },
    FS: { pl: "FS (Specyfikacja Funkcjonalna)", en: "FS (Functional Specification)" },
    DS: { pl: "DS (Specyfikacja Projektowa)", en: "DS (Design Specification)" },
    CL: { pl: "CL (Lista kontrolna)", en: "CL (Checklist)" },
    CUSTOM: { pl: "CUSTOM (Niestandardowy)", en: "CUSTOM (Custom)" },

    AC: { pl: "AC (Analiza krytyczności)", en: "AC (Criticality Analysis)" },
    ACS: { pl: "ACS (Analiza krytyczności systemu)", en: "ACS (System Criticality Analysis)" },
    ACM: { pl: "ACM (Analiza krytyczności modułów)", en: "ACM (Module Criticality Analysis)" },
    ACF: { pl: "ACF (Analiza funkcjonalności)", en: "ACF (Functionality Analysis)" },
    ACP: { pl: "ACP (Analiza krytyczności procesów)", en: "ACP (Process Criticality Analysis)" },
    VMP: { pl: "VMP (Validation Master Plan)", en: "VMP (Validation Master Plan)" },
    PROCEDURE: { pl: "PROCEDURE (Procedura)", en: "PROCEDURE (Procedure)" },
    INSTRUCTION: { pl: "INSTRUCTION (Instrukcja)", en: "INSTRUCTION (Instruction)" },
    FORM: { pl: "FORM (Formularz)", en: "FORM (Form)" },
};


export type DocTypeLabelVariant = "full" | "code";

export const DocumentTypesLabel: React.FC<{
    docType: DocumentTypes;
    variant?: DocTypeLabelVariant;
    lang?: string;
}> = ({ docType, variant = "full", lang = "pl" }) => {
    const entry = DOC_TYPE_LABELS[docType];
    if (!entry) return <>{docType}</>;

    if (variant === "code") return <>{docType}</>;
    if (variant === "full") return <>{lang === "pl" ? entry.pl : entry.en}</>;

    // default: "pl"
    return <>{entry.pl}</>;
};

export function getDocTypeLabel(docType: DocumentTypes, variant: DocTypeLabelVariant = "code", lang: "pl" | "en" = "pl") {
    const entry = DOC_TYPE_LABELS[docType];
    if (!entry) return docType;

    if (variant === "code") return docType;
    return lang === "pl" ? entry.pl : entry.en;
}